import { Component, Input } from '@angular/core';
import { Domain } from '../../models/domain.model';

@Component({
    selector: 'rms-domain-badges',
    templateUrl: './domain-badges.component.html',
    styleUrls: ['./domain-badges.component.scss'],
    standalone: false
})
export class DomainBadgesComponent {
  @Input() domains: Array<Domain>;
  @Input() fontSize = '7px';
  @Input() justifyContent = 'flex-end';
  /** Overrides the default 4px gap between badges when set. */
  @Input() gap: string;

  constructor() { }

  public getShortName (domain: Domain): string {
    const shortName = domain.shortName.toLowerCase();
    if (shortName === 'genmed') {
      return 'gen';
    }
    return shortName;
  }
}
